
import React, { useState, useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import { useForm, useFormContext, Controller, useFieldArray } from 'react-hook-form'
import { format } from 'date-fns';
import { toast } from 'components/Shared/Toast';
import { useQuery, useMutation } from 'react-query'
import CreatableSelect from 'react-select/creatable';
import { yupResolver } from '@hookform/resolvers/yup'
import {Collapse, Button, Media, ListGroupItem, ListGroup, FormGroup, Modal,ModalHeader,ModalBody,ModalFooter, UncontrolledTooltip, ButtonGroup} from 'reactstrap';
import Select from 'react-select';
import clsx from 'clsx';
import * as Yup from 'yup';
import produce from 'immer';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import DatePicker from 'components/Shared/DatePicker';
import { TenantGroupsSelect, useGroupList } from 'components/Shared/Selects/TenantGroupsSelect'

import bootbox from 'components/Modals/Bootbox';
import { useEditorState, useEditorActions } from '../../../editor-context'
import { fetcher } from 'api/client'
import { truncate } from 'utils'
import { resendParticipantEmail, contractAction } from 'api/actions/contracts'
import { useProfileState, useProfileAbility } from 'context/profile'
import { fetchMembers, addMember, fetchParticipant } from 'api/actions/agenda'
import { Checkbox } from './General'
import { reactSelectStyles } from 'components/Shared/ReactSelectStyles'

import { agendaFields } from 'components/Modals/AgendaModal'

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};


const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',

  // change background colour if dragging
  background: isDragging ? '#45616e' : '#354f5c',

  // styles we need to apply on draggables
  ...draggableStyle
});

 const swapModels = (participants, start, newIndex) => {

    const participantIndex = participants.findIndex(p => p.signOrder === start);
    const participant = participants[participantIndex];
    const signOriginal = participant.signOrder;

    console.log({participant, participantIndex, signOriginal, newIndex })
    if (participant && newIndex !== signOriginal) {
        return produce(participants, draft => {
            draft.forEach((part, i) => {
                if (newIndex > signOriginal && part.signOrder <= newIndex && part.signOrder > signOriginal) {
                    part.signOrder = part.signOrder - 1;
                } else if (part.signOrder >= newIndex && part.signOrder < signOriginal) {
                    part.signOrder = part.signOrder + 1;
                } 
                if (participantIndex === i) {
                    part.signOrder = newIndex;
                }
                // if (newIndex === 0)  part.unset('requireGroupValidation');
            })
        })
    }
    return participants;
  }

export function ParticipantList() {
    const { t } = useTranslation();
    const profileAbility = useProfileAbility();
    const canSetRequireCheckConfirmation = profileAbility.can('SET_REQUIRE_CHECK_CONFIRMATION');  // #can 'SET_REQUIRE_CHECK_CONFIRMATION'

    const { document: doc, isEditable } = useEditorState()
    const [participants, setParticipants] = useState(doc.participants ?? [])
    const { addParticipant, updateDocument } = useEditorActions()

    const { control, watch, reset, handleSubmit } = useFormContext();
    const handleChange  = () => {
        handleSubmit(({participants, ...data}) => { 
            if (data.signInOrder) {
                data.participants = doc.participants.map((p, i) => ({...p, signOrder: i})) 
            }
            updateDocument(data)
        }, (err) => console.log({err}))()
    }
    const handleAddParticipant = () => {
        addParticipant()
    }

    const handleDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
    
        const items = swapModels(
            participants,
            result.source.index,
            result.destination.index
        );
        
        updateDocument({ participants: items })
    
        setParticipants(items)
    }


    const signInOrder = watch('signInOrder', doc.signInOrder)

    function sortParticipants(array = [], signInOrder) {

        if (!signInOrder) return array;

        return array.slice().sort((a, b) => a.signOrder - b.signOrder)
    }

    useEffect(() => {
        if (doc.participants) {
            const parts = doc.participants?.map((p, i) => ({ ...p, requireGroupValidation: p.requireGroupValidation?._id || p.requireGroupValidation , index: i })) ?? [];
            setParticipants(parts)
            reset({ ...doc, participants: parts })
        }
    }, [doc.participants])

   

    return (
        <div className="">
            <div className="p-3">
                {isEditable && 
                    <Controller
                        control={control}
                        name="signInOrder" 
                        defaultValue={doc.signInOrder ?? false}
                        render={({ onChange, onBlur, value }) => (
                            <Checkbox 
                                id="signInOrder"
                                name="signInOrder"
                                label={t('editor.config.signInOrder')}
                                className=""
                                labelClassName="sign-in-order"
                                onBlur={onBlur}
                                checked={value}
                                onChange={(evt) => {
                                    onChange(evt.target.checked)
                                    handleChange(evt)
                                }}
                            />
                        )}
                    />
                }
                {isEditable && canSetRequireCheckConfirmation &&
                    <Controller
                        control={control}
                        name="signCheckConfirmation" 
                        defaultValue={doc.signCheckConfirmation ?? false}
                        render={({ onChange, onBlur, value }) => (
                            <Checkbox 
                                id="signCheckConfirmation"
                                name="signCheckConfirmation"
                                label={t('editor.config.signCheckConfirmation')}
                                className=""
                                labelClassName="sign-in-order"
                                onBlur={onBlur}
                                checked={value}
                                onChange={(evt) => {
                                    onChange(evt.target.checked)
                                    handleChange(evt)
                                }}
                                disabled={!isEditable}
                            />
                        )}
                    />
                }
            </div>
            <ListGroup>
            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="droppable" isDropDisabled={!signInOrder || !isEditable}  >
                    {(provided, snapshot) => (
                        <div 
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            className="participants-list"
                        >
                            {sortParticipants(participants, signInOrder)?.map((participant, index) => (
                                <Draggable 
                                    key={participant._id} 
                                    draggableId={participant._id} 
                                    index={index}
                                    isDragDisabled={!signInOrder || !isEditable} 
                                >
                                    {(provided, snapshot) => (
                                        <ParticipantItem 
                                            participant={participant} 
                                            index={(participant.index ?? index) + 1} 
                                            name={`participants[${participant.index ?? index}]`} 
                                            signInOrder={signInOrder} 
                                            jurisdiction={doc.jurisdiction} 
                                            isTestament={doc.isTestament} 
                                            documentId={doc._id}
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={getItemStyle(
                                                snapshot.isDragging,
                                                provided.draggableProps.style
                                            )}
                                        />
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
             </DragDropContext>
             </ListGroup>
            {isEditable && !doc.isTestament &&
            <div className="text-center m-1" >
                <Button color="light" onClick={handleAddParticipant} size="sm" data-action="add-participant">
                    <i className="fas fa-plus"></i> {t('editor.config.add_participant')}
                </Button>
                </div>
            }
        </div>
    )
}

const ParticipantItem = React.forwardRef(({ participant, name, index, documentId, signInOrder, jurisdiction, isTestament, ...props}, ref) => {
    const { t, i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [isChangeEmailOpen, setIsChangeEmailOpen] = useState(false);
    const [hasResentEmail, setHasResentEmail] = useState(false);
    const [hasAgendaProperties, setHasAgendaProperties] = useState(false);
    const [isAgendaPropertiesOpen, setIsAgendaPropertiesOpen] = useState(false);
    const { obligationsMap } = useObligationList({ jurisdiction })
    const { register, control, watch, setValue , handleSubmit, reset } = useFormContext({
    
    });
    const { mutate: mutateResendEmail } = useMutation((payload) => fetcher(resendParticipantEmail(payload)), {
        onSuccess: (data) => {
            toast.success(t('contracts.listing.send_successfull'));
        },
        onSettled: () => {
            
        }
    })
    const { mutate: mutateSetExpirationLink } = useMutation(({contractId, ...payload}) => fetcher(contractAction(contractId, 'setexpirationlink' , payload)), {
        onSuccess: (data) => {
            toast.success(t('success'));
        },
        onSettled: () => {
            
        }
    })

    const toggle = () => setIsOpen(open => !open);
    const { document: doc, isEditable, mode, isContentLocked } = useEditorState()
    const { addParticipant, removeParticipant, updateParticipant, updateDocument } = useEditorActions()
    const { profile } = useProfileState()
    const { groupsMap } = useGroupList();
    const profileAbility = useProfileAbility();

    const isDisabled = !isEditable || isTestament;
    const canRequestVideoRecording = profileAbility.can('REQUEST_VIDEO_RECORDING'); // #can 'REQUEST_VIDEO_RECORDING'
    const canRequestVeridoc = profileAbility.can('REQUEST_VERIDOC'); // #can 'REQUEST_VERIDOC'
    const canRequestIne = profileAbility.can('REQUEST_INE'); // #can 'REQUEST_INE'
    const canRequestMandatoryLocation = profileAbility.can('REQUEST_MANDATORY_LOCATION'); // #can 'REQUEST_MANDATORY_LOCATION'
    const canRequestOneTimePassword = profileAbility.can('REQUEST_ONE_TIME_PASSWORD'); // #can 'REQUEST_ONE_TIME_PASSWORD'
    const canRequestShield4 = profileAbility.can('REQUEST_SHIELD_4'); // #can 'REQUEST_SHIELD_4'
    const canSetGroupValidation = profileAbility.can('SET_GROUP_VALIDATION'); // #can 'REQUEST_SHIELD_4'
    const canSetContractParticipantViewExpiration = profileAbility.can('SET_CONTRACT_PARTICIPANT_VIEW_EXPIRATION'); // #can 'REQUEST_SHIELD_4'
    const canRequestIneOcr = profileAbility.can('REQUEST_INE_OCR');// profileAbility.can('REQUEST_INE_OCR'); // #can 'REQUEST_INE_OCR'
    const canSetCustomMessage = profileAbility.can('SET_CUSTOM_MESSAGE');

    const obligation = watch(`${name}.obligation`, participant.obligation);
    const linkExpirationDate = watch(`${name}.linkExpirationDate`, participant.linkExpirationDate);
    const editor = mode;
    const isParticipant =  watch(`${name}.userIsParticipant`, doc.userIsParticipant === profile._id);;
    const isOwner = profileAbility.can('modify', doc);;

    useEffect(() => {
        setHasAgendaProperties(!!participant?.agendaProperties?.agendaId)
    }, [participant.agendaProperties])

    
    const handleChange = (options) => {
        const { agendaProperties = {} } = options || {};
        const parseData = (data) => {
            const foundParticipant = data.participants?.find(p => p._id === participant._id)
            if (!foundParticipant) return {};

            console.log({foundParticipant})

            return {
                ...foundParticipant,
                agendaProperties: {
                    ...agendaProperties,
                    ...foundParticipant.agendaProperties,
                },
                participantId: foundParticipant._id,
                userIsParticipant: foundParticipant.userIsParticipant ? profile._id : undefined,
                obligation: foundParticipant.obligation ?? 'individual'
            }
        }

        handleSubmit((data) => updateParticipant(parseData(data)), (err) => console.log({err}))()
    }
    const handleIsParticipant = (active) => {
        if (active) {
            setValue(`${name}.name`, obligation === 'individual' ? profile.givenName : profile.office.name)
            setValue(`${name}.last_name`, obligation === 'individual' ? profile.familyName : '')
            setValue(`${name}.email`, profile.email)
            setValue(`${name}.phone`, profile.phone)
            setValue(`${name}.representative`, profile.office.representative)
            
        } else {
            setValue(`${name}.name`, '')
            setValue(`${name}.last_name`, '')
            setValue(`${name}.email`, null)
            setValue(`${name}.phone`,'')
            setValue(`${name}.representative`, '')
        }
    }

    const handleDelete = async () => {
        const confirm = await bootbox.confirm(t('editor.config.delete_part_warning'));

        if (!confirm) return;

        removeParticipant({ participantId: participant._id })
    }

    const handleResend = () => {
        setHasResentEmail(true)
        mutateResendEmail({
            documentId: doc._id,
            participantId: participant._id
        })
        setTimeout(() => setHasResentEmail(false), 3000)
    }

    const handleChangeEmail = () => {
        setIsChangeEmailOpen(true)
    }

    const handleParticipantSelected = (part) => {
        if (part) {
            setValue(`${name}.name`, obligation === 'individual' ? part.name : part.razonSocial)
            setValue(`${name}.last_name`, obligation === 'individual' ? part.last_name : '')
            setValue(`${name}.email`, part.value)
            setValue(`${name}.phone`, part.phone)
            setValue(`${name}.representative`, part.representanteLegal)
            if (part._id) {
                setValue(`${name}.agendaProperties.agendaId`, part._id)
                part.agendaId = part._id
            }
            agendaFields.map(field => {
                setValue(`${name}.agendaProperties.${field.propertyName}`, part?.[field.propertyName] || '')
            })
            updateParticipant({ participantId:participant._id, agendaProperties: part })
            setHasAgendaProperties(!!part?._id)
        } else {
            setValue(`${name}.name`, '')
            setValue(`${name}.last_name`, '')
            setValue(`${name}.email`, null)
            setValue(`${name}.phone`,'')
            setValue(`${name}.representative`, '')
            setValue(`${name}.agendaProperties.agendaId`, undefined)
            agendaFields.map(field => {
                setValue(`${name}.agendaProperties.${field.propertyName}`, '')
            })
            updateParticipant({ participantId:participant._id, agendaProperties: {} })
            setHasAgendaProperties(false)
        }
        
    }
 
    const handleRefetchAgendaPropertiese = async () => {
        console.log("Refetch agenda")
        if (!participant?.agendaProperties?.agendaId) return;
        try {
            const result = await fetcher(fetchParticipant({ participantId: participant.agendaProperties.agendaId }))
            result.value = result.email;
            handleParticipantSelected(result)
            handleChange({ agendaProperties: result })
            toast.success(t('Informacion actualizada'))
        } catch (error) {
            console.log({error})
            toast.error(t(`errors.${error.message}`, t('errors.GeneralError')))
        }
    }

    const handleChangeExpirationLink = () => {
        mutateSetExpirationLink({ contractId: documentId, participantId: participant._id, expirationDate: linkExpirationDate })
    }

    // const signOrder = participant.signOrder ? participant.signOrder + 1 : index;


    // console.log({participant});

    return (
        <div className={clsx('m-0 p-0', signInOrder && isEditable && 'sortable')} ref={ref} {...props }>
            <Media className="bg-light border text-dark d-flex align-items-center" onClick={toggle}>
                <Media className={clsx(`p-2 mr-2 participant${index}`, signInOrder && 'participant-with-order')} middle>
                    <img height="40px" className={clsx(signInOrder && 'part-img-with-order')} src={`/images/editor/icons/participants/${obligation}.svg`} alt={obligation} />
                    {signInOrder && <span className="participant-number">{typeof participant.signOrder !== 'undefined' ? participant.signOrder + 1 : index}</span> } {/** participant.signOrder ? participant.signOrder + 1 :  */}
                </Media>
                <Media body>
                    <Media>
                        {truncate(participant.label, 25)}
                        {
                            participant.status === 'SENT_SIGNED' && !participant.isNotSigner  ?
                                <i title={t(`contracts.status.${participant.status}`)} className="fas fa-check text-success ml-2"></i> 
                            : participant.status === 'RECEIVED_TO_SIGN' && !participant.isNotSigner ?
                                <i title={t(`contracts.status.${participant.status}`)} className="fas fa-exclamation-triangle text-warning ml-2"></i>
                            : null

                        } 
                    </Media>
                    <Media>
                        {editor === 'contract' ?
                            <>{participant.name} {obligation === 'individual' && participant.last_name}</>
                        : <>
                            {obligation === 'individual' ? 
                                t('editor.config.participant_individual', { context: jurisdiction })
                            : 
                                t('editor.config.participant_legal', { context: jurisdiction })}
                        </>}
                    </Media>
                </Media>
                <Media className="p-2">
                    <i className={`pointer fas fa-${isOpen ? 'chevron-down' : 'chevron-up'}`}></i>
                </Media>
            </Media>
            <Collapse className="bg-light-contrast" isOpen={isOpen}>
                <div className="d-flex justify-content-between align-items-center">
                <div className="pt-2">
                    { 
                        hasAgendaProperties && !isParticipant &&
                        <ParticipantIcon 
                            className="ml-2" 
                            icon="file-import" 
                            name={name}
                            id={`p${participant._id}refetchAgenda`}
                            active={false}
                            tooltip={t('Tomar datos de Agenda')}
                            onChange={handleRefetchAgendaPropertiese}
                            isDisabled={isDisabled}
                        />
                    }    
                    
                </div>
                <div className="text-center  d-flex justify-content-end px-2 pt-2">
                    <input type="hidden" ref={register()} name={`${name}._id`} defaultValue={participant._id} />
                    {/* <input type="hidden" ref={register()} name={`${name}.agendaProperties`} defaultValue={JSON.stringify(participant.agendaProperties)} /> */}
                    <Controller
                        control={control}
                        name={`${name}.isNotSigner`}
                        defaultValue={participant.isNotSigner ?? false}
                        render={({ onChange, onBlur, value, name}) => (
                            <ParticipantIcon 
                                className="ml-2" 
                                icon="signature" 
                                name={name}
                                id={`p${participant._id}isNotSigner`}
                                active={!value}
                                tooltip={t('editor.config.isNotSigner')}
                                onChange={({active}) => {
                                    onChange(!active)
                                    handleChange()
                                }}
                                isDisabled={isDisabled}
                            />
                        )}
                    />  
                    <Controller
                        control={control}
                        name={`${name}.isNotNegotiator`} 
                        defaultValue={participant.isNotNegotiator ?? false}
                        render={({ onChange, onBlur, value, name}) => (
                            <ParticipantIcon 
                                className="ml-2" 
                                icon="hands-helping" 
                                name={name}
                                id={`p${participant._id}isNotNegotiator`}
                                active={!value}
                                tooltip={t('editor.config.isNotNegotiator')}
                                onChange={({active}) => {
                                    onChange(!active)
                                    handleChange()
                                }}
                                isDisabled={isDisabled}
                            />
                        )}
                    />  
                    {editor === 'contract' &&
                        <Controller
                            control={control}
                            name={`${name}.userIsParticipant`} 
                            defaultValue={doc.userIsParticipant === profile._id ?? false}
                            render={({ onChange, name, value}) => (
                                <ParticipantIcon
                                    className="ml-2"
                                    icon="user" 
                                    name={name}
                                    id={`p${participant._id}userIsParticipant`}
                                    active={value}
                                    tooltip={t('editor.config.participant_me')} 
                                    onChange={({active}) => {
                                        onChange(active)
                                        handleIsParticipant(active)
                                        handleChange()
                                    }}
                                    isDisabled={isDisabled}
                                />
                            )}
                        />       
                    }
                    {!isParticipant && 
                        <Controller
                            control={control}
                            name={`${name}.requestAgreement`}
                            defaultValue={participant.requestAgreement ?? false}
                            render={({ onChange, onBlur, value, name}) => (
                                <ParticipantIcon 
                                    className="ml-2" 
                                    icon="camera" 
                                    name={name}
                                    id={`p${participant._id}requestAgreement`}
                                    active={value}
                                    tooltip={canRequestVideoRecording ? t('editor.config.shield3') : t('wordList.plans.availableOnPE')} 
                                    disabled={!canRequestVideoRecording}
                                    onChange={({active}) => {
                                        onChange(active)
                                        handleChange()
                                    }}
                                    isDisabled={isDisabled}
                                />
                            )}
                        />    
                    }
                    {!isParticipant && canRequestIne &&
                        <Controller
                            control={control}
                            name={`${name}.requestIne`}
                            defaultValue={participant.requestIne}
                            render={({ onChange, onBlur, value, name}) => (
                                <ParticipantIcon 
                                    className="ml-2" 
                                    icon="id-badge" 
                                    name={name}
                                    id={`p${participant._id}requestIne`}
                                    active={value}
                                    tooltip="INE"
                                    onChange={({active}) => {
                                        onChange(active)
                                        setValue(`${name}.requestVeridoc`, false)
                                        handleChange()
                                    }}
                                    isDisabled={isDisabled}
                                />
                            )}
                        />  
                    }
                     {!isParticipant && canRequestVeridoc &&
                        <Controller
                            control={control}
                            name={`${name}.requestVeridoc`}
                            defaultValue={participant.requestVeridoc ?? false}
                            render={({ onChange, onBlur, value, name}) => (
                                <ParticipantIcon 
                                    className="ml-2" 
                                    icon="id-card" 
                                    name={name}
                                    id={`p${participant._id}requestVeridoc`}
                                    active={value}
                                    tooltip="INE-Selfie"
                                    onChange={({active}) => {
                                        onChange(active)
                                        setValue(`${name}.requestIne`, false)
                                        handleChange()
                                    }}
                                    isDisabled={isDisabled}
                                />
                            )}
                        />  
                    }
                    {!isParticipant && canRequestIneOcr &&
                        <Controller
                            control={control}
                            name={`${name}.requestIneOCR`}
                            defaultValue={participant.requestIneOCR ?? false}
                            render={({ onChange, onBlur, value, name}) => (
                                <ParticipantIcon 
                                    className="ml-2" 
                                    icon="address-card" 
                                    name={name}
                                    id={`p${participant._id}requestIneOCR`}
                                    active={value}
                                    tooltip="OCR-INE"
                                    onChange={({active}) => {
                                        onChange(active)
                                        handleChange()
                                    }}
                                    isDisabled={isDisabled}
                                />
                            )}
                        />  
                    }
                    {!isParticipant && canRequestMandatoryLocation &&
                        <Controller
                            control={control}
                            name={`${name}.requestLocation`} 
                            defaultValue={participant.requestLocation ?? false}
                            render={({ onChange, onBlur, value, name}) => (
                                <ParticipantIcon 
                                    className="ml-2" 
                                    icon="map-marker-alt" 
                                    name={name}
                                    id={`p${participant._id}requestLocation`}
                                    active={value}
                                    tooltip={t('editor.config.geolocation_required')}
                                    onChange={({active}) => {
                                        onChange(active)
                                        handleChange()
                                    }}
                                    isDisabled={isDisabled}
                                />
                            )}
                        />  
                    }
                    {!isParticipant && canRequestOneTimePassword &&
                        <Controller
                            control={control}
                            name={`${name}.requestOneTimePassword`} 
                            defaultValue={participant.requestOneTimePassword ?? false}
                            render={({ onChange, onBlur, value, name}) => (
                                <ParticipantIcon 
                                    className="ml-2" 
                                    icon="lock"
                                    name={name}
                                    id={`p${participant._id}requestOneTimePassword`}
                                    active={value}
                                    tooltip={t('editor.config.one_time_password_required')}
                                    onChange={({active}) => {
                                        onChange(active)
                                        handleChange()
                                    }}
                                    isDisabled={isDisabled}
                                />
                            )}
                        />  
                    }
                    {/* {!isParticipant && canRequestShield4 &&
                        <Controller
                            control={control}
                            name={`${name}.shield4DataRequested`} 
                            defaultValue={participant.shield4DataRequested ?? false}
                            render={({ onChange, onBlur, value, name}) => (
                                <ParticipantIcon 
                                    className="ml-2" 
                                    icon="fingerprint" 
                                    name={name}
                                     id={`p${participant._id}shield4DataRequested`}
                                    active={value}
                                    tooltip={t('editor.config.shield4DataRequested')}
                                    onChange={({active}) => {
                                        onChange(active)
                                        handleChange()
                                    }}
                                    isDisabled={isDisabled}
                                />
                            )}
                        />  
                    } */}
                </div>
                </div>
                <div className="p-2">
                    <FormGroup>
                        <label className="text-dark">{t('editor.config.participant_type')}</label>
                        <Controller
                            control={control}
                            name={`${name}.obligation`}
                            defaultValue={participant.obligation || 'individual'}
                            render={({ onChange, onBlur, value}) => (
                                <ObligationSelect
                                    jurisdiction={doc.jurisdiction}
                                    onChange={(value, option) => {
                                        onChange(value)
                                        handleChange()
                                    }}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                        }),
                                    }}
                                    value={value}
                                    onBlur={onBlur}
                                    isDisabled={isDisabled}
                                />
                            )}
                        />
                    </FormGroup>
                    <FormGroup>
                        <label className="text-dark">{t('editor.config.participant_role')}*</label>
                        <input 
                            type="text" 
                            className="form-control input-sm" 
                            placeholder={t('editor.config.participant_role_placeholder')} 
                            name={`${name}.label`}
                            ref={register()}
                            onBlur={handleChange}
                            defaultValue={participant.label || ''} 
                            disabled={isDisabled}
                            readOnly={isDisabled}
                        />
                    </FormGroup>
                    <FormGroup>
                        <label className="text-dark">{t('editor.config.participant_email')}*</label>
                        <Controller
                            control={control}
                            name={`${name}.email`}
                            defaultValue={participant.email || null}
                            render={({ onChange, onBlur, value}) => (
                                <ParticipantsSelect
                                    onChange={(value, option) => {
                                        handleParticipantSelected(option)
                                        onChange(value)
                                        handleChange({ agendaProperties: option })
                                    }}
                                    value={value}
                                    onBlur={onBlur}
                                    isDisabled={isDisabled}
                                    placeholder={t('editor.config.participant_email_placeholder')}
                                />
                            )}
                        />
                    </FormGroup>
                    <FormGroup>
                        <label className="text-dark">
                            {t(`editor.config.${obligation === 'legal' ? 'participant_rz' : obligation === 'legal' && jurisdiction === 'br' ? 'participant_cn' : 'participant_name'}`)}*
                        </label>
                        <input 
                            type="text" 
                            className="form-control input-sm" 
                            placeholder={t(`editor.config.${obligation === 'legal' ? 'participant_cn_placeholder' : obligation === 'legal' && jurisdiction === 'br' ? 'participant_rz_placeholder' : 'participant_name_placeholder'}`)}
                            name={`${name}.name`}
                            ref={register()}
                            onBlur={handleChange}
                            defaultValue={participant.name || ''} 
                            disabled={isDisabled}
                            readOnly={isDisabled}
                        />
                    </FormGroup>
                    {obligation === 'individual' &&
                        <FormGroup>
                            <label className="text-dark">{t('editor.config.participant_last_name')}*</label>
                            <input 
                                type="text" 
                                className="form-control input-sm" 
                                placeholder={t('editor.config.participant_last_name_placeholder')} 
                                name={`${name}.last_name`} 
                                ref={register()}
                                defaultValue={participant.last_name || ''}  
                                onBlur={handleChange}
                                disabled={isDisabled}
                                readOnly={isDisabled}
                            />
                        </FormGroup>
                    }
                    <FormGroup>
                        <label className="text-dark">{t('editor.config.participant_phone')}</label>
                        <input 
                            type="text" 
                            className="form-control input-sm" 
                            placeholder={t('editor.config.participant_phone_placeholder')} 
                            name={`${name}.phone`} 
                            ref={register()}
                            onBlur={handleChange}
                            defaultValue={participant.phone || ''}
                            disabled={isDisabled}
                            readOnly={isDisabled}
                        />
                    </FormGroup>

                    {obligation === 'legal' &&
                        <FormGroup>
                            <label className="text-dark">
                                {jurisdiction === 'br' ?
                                    t('editor.config.participant_name')
                                :
                                    t('editor.config.participant_representative')
                                }
                            </label>
                            <input 
                                type="text" 
                                required 
                                className="form-control input-sm" 
                                name={`${name}.representative`} 
                                ref={register()}
                                onBlur={handleChange}
                                defaultValue={participant.representative || ''}
                                placeholder={t('editor.config.participant_representative')} 
                                disabled={isDisabled}
                                readOnly={isDisabled}
                            />
                        </FormGroup>
                    }
                {jurisdiction === 'br'  &&
                    <>
                        <FormGroup>
                            <label className="text-dark">Cargo</label>
                            <input 
                                type="text" 
                                required 
                                className="form-control input-sm" 
                                name={`${name}.cargo`} 
                                placeholder="cargo"
                                ref={register()}
                                onBlur={handleChange}
                                defaultValue={participant.cargo || ''}
                                disabled={isDisabled}
                                readOnly={isDisabled}
                            />
                        </FormGroup>
                        <FormGroup>
                            <label className="text-dark">RG</label>
                            <input 
                                type="text" 
                                required 
                                className="form-control input-sm" 
                                name={`${name}.rg`}
                                ref={register()}
                                onBlur={handleChange}
                                defaultValue={participant.rg || ''}
                                placeholder="rg"
                                disabled={isDisabled}
                                readOnly={isDisabled}
                            />
                        </FormGroup>
                        <FormGroup>
                            <label className="text-dark">CPF</label>
                            <input 
                                type="text" 
                                required 
                                className="form-control input-sm" 
                                name={`${name}.cpf`} 
                                ref={register()}
                                onBlur={handleChange}
                                defaultValue={participant.cpf || ''}
                                placeholder="cpf"
                                disabled={isDisabled}
                                readOnly={isDisabled}
                            />
                        </FormGroup>
                    </>
                }
                {jurisdiction === 'co' &&
                    <FormGroup>
                        <label className="text-dark">Cédula no.</label>
                        <input 
                            type="text" 
                            required 
                            className="form-control input-sm" 
                            name={`${name}.cpf`} 
                            ref={register()}
                            onBlur={handleChange}
                            defaultValue={participant.cpf || ''}
                            placeholder="Cédula no."
                            disabled={isDisabled}
                            readOnly={isDisabled}
                        />
                    </FormGroup>
                }
                {jurisdiction === 'pr' && 
                    <FormGroup>
                        <label className="text-dark">DNI/C.E./otro</label>
                        <input 
                            type="text" 
                            required 
                            className="form-control input-sm" 
                            name={`${name}.cpf`}
                            ref={register()}
                            onBlur={handleChange}
                            defaultValue={participant.cpf || ''}
                            placeholder="DNI/C.E./otro"
                            disabled={isDisabled}
                            readOnly={isDisabled}
                        />
                    </FormGroup>
                }
                {canSetGroupValidation && signInOrder && !!participant.signOrder &&
                    <FormGroup>
                        <label className="text-dark">{t('editor.config.requireUserValidation')}</label>
                        <Controller
                            control={control}
                            name={`${name}.requireGroupValidation`} 
                            defaultValue={participant.requireGroupValidation?._id ? participant.requireGroupValidation._id : null}
                            render={({ onChange, onBlur, value}) => (
                                <TenantGroupsSelect
                                    isClearable
                                    onChange={(value, option) => {
                                        onChange(value)
                                        handleChange(option)
                                    }}
                                    onBlur={onBlur}
                                    placeholder={t('editor.config.requireGroupValidation_placeholder')}
                                    value={value}
                                    isDisabled={isDisabled}
                                />
                            )}
                        />
                    </FormGroup>
                }
                {editor === 'contract'  && canSetContractParticipantViewExpiration &&
                    <FormGroup>
                        <label className="text-dark">{t('editor.config.link_expiration')}</label>
                        <div className="d-flex link-expiration-date">
                            <Controller
                                control={control}
                                name={`${name}.linkExpirationDate`}
                                defaultValue={participant.linkExpirationDate || null}
                                render={({ onChange, onBlur, value}) => (
                                        <DatePicker
                                            locale={i18n.language}
                                            selected={value ? new Date(value) : null}
                                            onChange={(date) => {
                                                onChange(date)
                                                handleChange()
                                            }}
                                            onBlur={onBlur}
                                            disabled={!isOwner}
                                            data-action="set-link-expiration" 
                                            customInput={<input className="form-control input-sm" type="text" />}
                                            dateFormat="dd/MMM/yyyy"
                                            placeholderText={t('editor.config.expiration_date_placeholder')} 
                                            fullWidth
                                        />
                                )}
                            />
                            <button 
                                className="btn btn-sm btn-primary btn-block d-flex ml-1 align-items-center" 
                                style={{width: 80}} 
                                data-action="change-expiration-date"
                                onClick={handleChangeExpirationLink} 
                                disabled={!isOwner || isTestament}
                                readOnly={!isOwner || isTestament}
                            >
                                <i className="fas fa-eye mr-1"></i> {t('editor.config.change')}
                            </button>
                        </div>
                    </FormGroup>
                }
                {canSetCustomMessage && !isTestament &&
                    <FormGroup>
                        <label className="text-dark">{t('editor.config.customMessage')}</label>
                        <div className="d-flex">
                         <textarea 
                                className="form-control input-sm"
                                placeholder={t('editor.config.customMessage_placeholder') } 
                                name={`${name}.customMessage`}
                                ref={register()}
                                onBlur={handleChange}
                                defaultValue={participant.customMessage || ''}
                         />
                        </div>
                    </FormGroup>
                }
                <div className="mb-1 font-weight-bold" onClick={() => setIsAgendaPropertiesOpen(!isAgendaPropertiesOpen)}>Agenda <i className={`fas pointer fa-chevron-${isAgendaPropertiesOpen ? 'up' : 'down'}`}></i></div>
                <Collapse className="bg-light-contrast" isOpen={isAgendaPropertiesOpen}>
                <input type="hidden" ref={register()} name={`${name}.agendaProperties.agendaId`} defaultValue={participant?.agendaProperties?.agendaId} />
                {
                    agendaFields.map(field => {
                        return (
                            <FormGroup>
                                <label className="text-dark">{t(`agenda.${field.propertyName}_placeholder`)}</label>
                                {
                                    field.type === 'calendar' ?
                                        <Controller 
                                            control={control}
                                            name={`${name}.agendaProperties.${field.propertyName}`}
                                            defaultValue={participant?.agendaProperties?.[field.propertyName] ? new Date(participant?.agendaProperties?.[field.propertyName]) : null}
                                            render={({ onChange, onBlur, value}) => (
                                                <DatePicker
                                                    locale={i18n.language}
                                                    selected={value ? new Date(value) : null}
                                                    onChange={(date) => {
                                                        onChange(date)
                                                        handleChange()
                                                    }}
                                                    onBlur={onBlur}
                                                    disabled={!isOwner}
                                                    customInput={<input className="form-control input-sm" type="text" />}
                                                    dateFormat="PPP"
                                                    placeholderText={t(`agenda.${field.propertyName}_placeholder`)}
                                                    fullWidth
                                                />
                                            )}  
                                        />
                                        
                                    : <input 
                                        type="text" 
                                        required 
                                        className="form-control input-sm" 
                                        name={`${name}.agendaProperties.${field.propertyName}`}
                                        ref={register()}
                                        onBlur={handleChange}
                                        defaultValue={participant?.agendaProperties?.[field.propertyName] || ''}
                                        placeholder={t(`agenda.${field.propertyName}_placeholder`)}
                                        disabled={isDisabled}
                                        readOnly={isDisabled}
                                    />
                                }
                                
                            </FormGroup>
                        )
                    })
                }
                </Collapse>
                {editor === 'contract'  && ['RECEIVED_TO_SIGN', 'RECEIVED_TO_FILL', 'RECEIVED_TO_DOWNLOAD', 'PENDING_NEGOTIATION', 'ACCEPTED_NEGOTIATION'].includes(participant.status) && !hasResentEmail &&
                    <>
                        <button 
                            className="btn btn-sm btn-success btn-block"
                            data-action="resend-email"
                            onClick={handleResend}
                            disabled={!isOwner}
                            readOnly={!isOwner}
                        >
                            <i className="fas fa-share-square"></i> {t('editor.config.resend')}
                        </button>
                        {!isParticipant && 
                            <button 
                                className="btn btn-sm btn-default btn-block" 
                                data-action="change-email" 
                                onClick={handleChangeEmail}
                                disabled={!isOwner}
                                readOnly={!isOwner}
                            >
                                <i className="fas fa-share-square"></i> {t('editor.config.change_email')}
                            </button>
                    }
                    </>
                }
           
                {isEditable && !isContentLocked && !isTestament &&
                <div className="text-right" >
                    <Button color="light" className="text-danger" data-action="remove" size="sm" onClick={handleDelete}>
                        <i className="fas fa-times"></i> {t('editor.config.participant_delete')}
                    </Button>
                </div>
                }
            </div>
            </Collapse>
            <DelegateSignatureModal 
                isChangeParticipant
                isOpen={isChangeEmailOpen} 
                jurisdiction={doc.jurisdiction} 
                contractId={doc._id} 
                participant={participant} 
                onClose={() => setIsChangeEmailOpen(false)} 
                onSuccess={(data) => {
                    updateDocument(data.contract); 
                    const updatedParticipant = data.contract.participants.find(p => p._id === participant._id)
                    reset(updatedParticipant)
                }} 
            />
        </div>
    )
})



function ParticipantIcon({ className, id, name, icon, active, tooltip, isDisabled, onChange }) {
    const styles = useMemo(() => {
        const style = {
            cursor: 'pointer'
        }

        style.color = active ? '#bcc360' : '#40444a';

        if (isDisabled) {
            style.color = active ? '#bcc360' : '#40444a'; //#a5a5a5
            style.opacity = 0.7;
            style.cursor = 'not-allowed'; 
            style.marginLeft = 2;
        }

        return style
    }, [active, isDisabled])

    const handleClick = () => {
        if (isDisabled) return;

        onChange({ active: !active })
    }

    return (
        <>
            <i 
                className={clsx(`fas fa-${icon} pointer`, className)}
                name={name}
                id={id}
                // checked={isParticipant} 
                onClick={handleClick}
                style={styles} 
            />
            {name && tooltip && <UncontrolledTooltip target={id}>{tooltip}</UncontrolledTooltip>}
        </>
    )
}

export function ParticipantsSelect({ value, onChange, ...props}) {
    const [options, setOptions] = useState([]);
    const [search, setSearch] = useState('');
    const [realValue, setRealValue] = useState(null);
    const { t } = useTranslation();
    const { data, isLoading,  } = useQuery(['participants',  { search }], () => fetcher(fetchMembers({ search })), {
        onSuccess: (data) => {
            
            const options = data.docs?.map(d => {
                let label = d.email;
                
                if (!!d.razonSocial || !!d.name) {
                    label = `${label} (${d.razonSocial || `${d.name || ''} ${d.last_name || ''}`})`
                }

                return { label , value: d.email, ...d }
            }) ?? [];
            setOptions(options)
        }
    })
    const { mutate: mutateAddMember, isLoading: isLoadingAddMember } = useMutation((payload) => fetcher(addMember(payload)), {
        onSuccess: (data) => {
            const newValue = { label: data.email , value: data.email, ...data };
            onChange(data.email, newValue)
            setRealValue(newValue)
        }
    })

    const handleCreate = async (inputValue) => {
        // await mutateAddMember({ email: inputValue });
        const newValue = { label: inputValue , value: inputValue };
        onChange(inputValue, newValue)
        setRealValue(newValue)
    };

    const handleInputChange = (inputValue) => {
        setSearch(inputValue)
    }
    const handleNewOptionData = (inputValue, optionLabel) => {
        return {
            value: inputValue,
            label: optionLabel,
            __isNew__: true,
            isEqual: () => false
        }
    }


    useEffect(() => {
        if (value) {
            setRealValue({ label: value, value })
        } else {
            setRealValue(null)
        }
    }, [value])

    const handleChange = (option) => {
        onChange(option?.value || null, option)
    }
    // const fetchOptions = async () => {
    //     const data = await fetcher(fetchMembers())

    //     return data.map(d => ({ label: d.email , value: d.email }))
    // }


    return (
        <CreatableSelect
            isClearable
            isDisabled={isLoading || isLoadingAddMember}
            isLoading={isLoading || isLoadingAddMember}
            onInputChange={handleInputChange}
            getNewOptionData={handleNewOptionData}
            onCreateOption={handleCreate}
            options={options}
            onChange={handleChange}
            value={realValue}
            styles={reactSelectStyles}
            formatCreateLabel={(inputValue) => t('editor.action.create')+' "'+inputValue+'"'}
            loadingMessage={() => t('editor.info.loading')}
            noOptionsMessage={() => t('editor.info.noOptions')}
            {...props}
        />
    )
}
export function useObligationList({ jurisdiction = 'mx' }) {
    const { t } = useTranslation();

    const obligationsMap = useMemo(() => {
        return new Map([
            ['individual', { label: t('editor.config.participant_individual', { context: jurisdiction }), value: 'individual', description: t('editor.config.participant_individual') }],
            ['legal', { label: t('editor.config.participant_legal', { context: jurisdiction }), value: 'legal', description: t('editor.config.participant_legal', { context: jurisdiction }) }],
        ])
    }, [t])
    
    return { obligationsMap, obligationsArray: Array.from(obligationsMap.values()) }
}

function ObligationSelect({jurisdiction, value, onChange, ...props}) {
   const { obligationsArray, obligationsMap } = useObligationList({ jurisdiction })
   const [realValue, setRealValue] = useState(null);


   useEffect(() => {
       if (obligationsMap.get(value)) {
           setRealValue(obligationsMap.get(value))
       } else {
           setRealValue(null)
       }
   }, [obligationsMap, value])

   const handleChange = (option) => {
       onChange(option?.value || null, option)
    }

    return (
        <Select
            options={obligationsArray}
            value={realValue}
            onChange={handleChange}
            {...props}
            styles={{...props.styles, ...reactSelectStyles}}
        />
    )
}

export const getParticipantSchema = ({ validateAgendaProperties = false } = {}) => Yup.lazy(participant => {
    const schema = {
        name: Yup.string()
        .required('Required'),
        obligation: Yup.string(),
        email: Yup.string()
          .email('InvalidEmail')
          .required('Required'),
        phone: Yup.string(),
    }
    if (participant?.obligation === 'legal') {
        schema.representative = Yup.string().required('Required');
    }  else {
        schema.last_name = Yup.string().required('Required');
    }
    const agendaPropertiesKeys = Object.keys(participant?.agendaProperties || {});
    if (agendaPropertiesKeys.length > 0 && validateAgendaProperties) {
        schema.agendaProperties = {}
        agendaPropertiesKeys.map(key => {
            if (key !== 'agendaId') {
                schema.agendaProperties[key] = Yup.string().required('Required');
            }
        })
        schema.agendaProperties = Yup.object().shape(schema.agendaProperties)
    }

    return Yup.object().shape(schema);
})

function DelegateSignatureModal({ isOpen, isChangeParticipant, contractId, jurisdiction, participant, onClose, onSuccess }) {
    const { t } = useTranslation();
    const { register, watch, control, errors, getValues, handleSubmit } = useForm({
        resolver: yupResolver(getParticipantSchema())
    })
    const obligation = watch('obligation', participant.obligation || 'individual');
    const { mutate: mutateDelegateSign} = useMutation(({ contractId, ...payload}) => fetcher(contractAction(contractId, 'delegatesign' , payload)), {
        onSuccess: (data) => {
           onClose()
           onSuccess(data)
        },
        onError: (error) => {
            toast.error(t(`errors.${error.message}`, t('errors.GeneralError')))
        }
    })

    const changeParticipant = async (data) => {
        let delegateQuestion = t('contracts.new.delegate_signature',  { name: data.name, last_name: data.last_name })
		if (isChangeParticipant) delegateQuestion = t('contracts.new.ask_change_participant');

        const res = await bootbox.confirm(delegateQuestion);
        if (!res) return;

        mutateDelegateSign({
            ...participant,
            ...data,
            participantId: participant._id,
            contractId,
            isChangeParticipant
        })
    }

    const handleSend = async () => {
        handleSubmit(() => {
            const data = getValues();
            changeParticipant(data)
        })()
    }
    
    if (!isOpen) {
        return null;    
    }

    return (
        <Modal isOpen={isOpen} centered>
        <ModalHeader toggle={onClose}>
                    {isChangeParticipant ? t('sign.sign.change_participant') :  <h4>{t('sign.sign.delegate_title')}</h4>}
                    {!isChangeParticipant && <p className="sub-title text-muted">{t('sign.sign.delegate_subtitle')}</p>}
        </ModalHeader>
        <ModalBody className="p-2 d-flex flex-column">
                <div className="fields">
                    <div className="col-xs-6 form-group">
                        <label>{t('editor.config.participant_type') }<span className="text-primary">*</span></label>
                        <Controller
                            control={control}
                            name="obligation" 
                            defaultValue={participant.obligation}
                            render={({ onChange, onBlur, value}) => (
                                <ObligationSelect
                                    jurisdiction={jurisdiction}
                                    onChange={(value, option) => {
                                        onChange(value)
                                    }}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            maxHeight: 35
                                        }),
                                        container: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            height: 30
                                        }),
                                    }}
                                    value={value}
                                    onBlur={onBlur}
                                />
                            )}
                        />
                    </div>
                    { obligation === 'individual' && 
                        <div className="col-xs-6 form-group" id="name">
                            <label>{t('sign.sign.delegate_name')}<span className="text-primary">*</span></label>
                            <input 
                                type="text" 
                                className={clsx('form-control input-sm',  errors.name && 'is-invalid')}
                                name="name" 
                                placeholder={t('sign.sign.delegate_name_placeholder') } 
                                defaultValue={participant.name}
                                ref={register}
                            />
                            <small className="text-danger"> {errors.name && t(`errors.${errors.name?.message}`)}</small>
                        </div>
                    }
                    { obligation === 'legal' &&
                        <div className="col-xs-6 form-group" id="participant_company">
                            <label>{t('sign.sign.delegate_participant_company') }:</label>
                            <input 
                                type="text" 
                                className="form-control input-sm" 
                                name="name" 
                                className={clsx('form-control input-sm',  errors.name && 'is-invalid')}
                                placeholder={t('sign.sign.delegate_participant_company_placeholder') } 
                                defaultValue={participant.name}
                                ref={register}
                            />
                            <small className="text-danger"> {errors.name && t(`errors.${errors.name?.message}`)}</small>
                        </div>
                    }
                    { obligation === 'individual' && 
                        <div className="col-xs-6 form-group" id="lastname">
                            <label>{t('sign.sign.delegate_last_name') }<span className="text-primary">*</span></label>
                            <input 
                                type="text" 
                                name="last_name" 
                                className={clsx('form-control input-sm',  errors.last_name && 'is-invalid')}
                                defaultValue={participant.last_name}
                                placeholder={t('sign.sign.delegate_last_name_placeholder')}
                                ref={register}
                            />
                            <small className="text-danger"> {errors.last_name && t(`errors.${errors.last_name?.message}`)}</small>
                        </div>
                    }
                    { obligation === 'legal' &&
                        <div className="col-xs-6 form-group" id="representative">
                            <label>{t('sign.sign.delegate_last_representative') }</label>
                            <input 
                                type="text" 
                                className={clsx('form-control input-sm',  errors.representative && 'is-invalid')}
                                name="representative" 
                                defaultValue={participant.representative}
                                placeholder={t('sign.sign.delegate_last_representative_placeholder') }
                                ref={register}
                            />
                            <small className="text-danger"> {errors.representative && t(`errors.${errors.representative?.message}`)}</small>
                        </div>
                    }
                    <div className="col-xs-6 form-group">
                        <label>{t('sign.sign.delegate_email') }<span className="text-primary">*</span></label>
                        <input 
                            type="text" 
                            className={clsx('form-control input-sm',  errors.email && 'is-invalid')}
                            name="email"
                            defaultValue={participant.email}
                            placeholder={t('sign.sign.delegate_email_placeholder') } 
                            ref={register}
                        />
                        <small className="text-danger"> {errors.email && t(`errors.${errors.email?.message}`)}</small>
                    </div>
                    
                    <div className="col-xs-6 form-group">
                        <label>{t('sign.sign.delegate_phone') }</label>
                        <input 
                            type="text" 
                            className={clsx('form-control input-sm',  errors.phone && 'is-invalid')}
                            name="phone" 
                            defaultValue={participant.phone}
                            placeholder={t('sign.sign.delegate_phone_placeholder') } 
                            ref={register}
                        />
                        <small className="text-danger"> {errors.phone && t(`errors.${errors.phone?.message}`)}</small>
                    </div>
                        {jurisdiction === 'br' && <>
                            <div className="col-xs-6 form-group">
                                <label>Cargo</label>
                                <input 
                                    type="text" required 
                                    className={clsx('form-control input-sm',  errors.cargo && 'is-invalid')}
                                    name="cargo" 
                                    defaultValue={participant.cargo}
                                    placeholder="cargo" 
                                    ref={register}
                                />
                                <small className="text-danger"> {errors.cargo && t(`errors.${errors.cargo?.message}`)}</small>
                            </div>
                            <div className="col-xs-6 form-group">
                                <label>RG</label>
                                <input 
                                    type="text" 
                                    required 
                                    className="form-control input-sm" 
                                    name="rg" 
                                    className={clsx('form-control input-sm',  errors.rg && 'is-invalid')}
                                    placeholder="rg" 
                                    defaultValue={participant.rg}
                                    ref={register}
                                />
                                <small className="text-danger"> {errors.rg && t(`errors.${errors.rg?.message}`)}</small>
                            </div>
                            <div className="col-xs-6 form-group">
                                <label>CPF</label>
                                <input 
                                    type="text" 
                                    required 
                                    className={clsx('form-control input-sm',  errors.cpf && 'is-invalid')}
                                    name="cpf"
                                    placeholder="cpf" 
                                    defaultValue={participant.cpf}
                                    ref={register}
                                />
                                <small className="text-danger"> {errors.cpf && t(`errors.${errors.cpf?.message}`)}</small>
                            </div>
                    </>}
                    {jurisdiction === 'pr' && <>
                        <div className="col-xs-6 form-group">
                            <label>DNI/C.E./otro</label>
                            <input 
                                type="text" 
                                required 
                                className="form-control input-sm" 
                                name="cpf" 
                                className={clsx('form-control input-sm',  errors.cpf && 'is-invalid')}
                                placeholder="DNI/C.E./otro" 
                                defaultValue={participant.cpf}
                                ref={register}
                            />
                            <small className="text-danger"> {errors.cpf && t(`errors.${errors.cpf?.message}`)}</small>
                        </div>
                        <div className="col-xs-6 form-group">
                            <label>Cargo</label>
                            <input 
                                type="text" 
                                required 
                                className="form-control input-sm" 
                                name="cargo" 
                                className={clsx('form-control input-sm',  errors.cargo && 'is-invalid')}
                                placeholder="cargo" 
                                defaultValue={participant.cargo}
                                ref={register}
                            />
                            <small className="text-danger"> {errors.cargo && t(`errors.${errors.cargo?.message}`)}</small>
                        </div>
                    </>}
                </div>
                
        </ModalBody>
                <ModalFooter>
                    <ButtonGroup className="d-flex flex-grow-1">
                        <Button color="default" data-action="cancel" onClick={onClose}>{t('sign.sign.delegate_cancel')}</Button>
                        <Button color="primary" data-action="send" onClick={handleSend}>
                            {isChangeParticipant ? t('sign.sign.change_send') : t('sign.sign.delegate_send')}
                        </Button>
                    </ButtonGroup>
                  </ModalFooter>
 
        </Modal>
    )
}